import React from 'react';
import logComponent from '../../common/logComponent';
import getImageTypeFromBase64 from '../../common/getImageTypeFromBase64';
import DefaultMonitoredIndividualIcon from '../DefaultMonitoredIndividualIcon/DefaultMonitoredIndividualIcon';

export default function MonitoredIndividualImage(monitoredIndividual) {
  const { monitoredIndividual: monitoredIndividualSelected } = monitoredIndividual;
  if (logComponent('MonitoredIndividualIcon')) { console.debug('MonitoredIndividualIcon render'); }


  return (
    <div>
      {(monitoredIndividualSelected != null && monitoredIndividualSelected.photo != null) &&

        <img
          className="MonitoredIndividualImage__photo"
          style={{
            "height": "105%", "width": "105% ", "object-fit": "fill" }}
        src={`data:${getImageTypeFromBase64(monitoredIndividualSelected.photo)};base64,${monitoredIndividualSelected.photo}`}
        alt={`For individual ${monitoredIndividualSelected.legalFirstName} ${monitoredIndividualSelected.lastName}`}
          />
        
      }
      {
        (monitoredIndividualSelected == null || monitoredIndividualSelected.photo == null) &&
        <DefaultMonitoredIndividualIcon />
      }
      
    </div>
    
  );
}

//